import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Importe o novo componente de Layout
import MainLayout from './components/main_layout/MainLayout';

// Importe suas páginas
import HomePage from './components/home_screen/Home';
import Cadastro from './components/cadastro_de_cliente_e_planos_1/Cadastro';
import Login from './components/auth/Login';
import DashboardCliente from './components/dashboard_do_cliente_1/DashboardCliente'; // Manter por compatibilidade se necessário, mas idealmente remover
import DashboardAdmin from './components/dashboard_administrativo_1/DashboardAdmin'; // Manter por compatibilidade se necessário

// Layouts
import AdminLayout from './components/layouts/AdminLayout';
import ClientLayout from './components/layouts/ClientLayout';

// Admin Pages
import AdminDashboard from './components/admin/AdminDashboard';
import AdminUsuarios from './components/admin/AdminUsuarios';
import AdminPlanos from './components/admin/AdminPlanos';
import AdminRelatorios from './components/admin/AdminRelatorios';
import AdminConfiguracoes from './components/admin/AdminConfiguracoes';
import AdminAjuda from './components/admin/AdminAjuda';
import SinapiUpload from './components/admin/SinapiUpload';

// Client Pages
import ClientDashboard from './components/client/ClientDashboard';
import ClientNovoOrcamento from './components/client/ClientNovoOrcamento';
import ClientHistorico from './components/client/ClientHistorico';
import ClientConfiguracoes from './components/client/ClientConfiguracoes';
import ClientPerfil from './components/client/ClientPerfil';
import ClientAjuda from './components/client/ClientAjuda';
import Recursos from './components/home_screen/Recursos';
import Servicos from './components/home_screen/Servicos';
import Precos from './components/home_screen/Precos';
import Contato from './components/home_screen/Contato';
import TermosDeServico from './components/legal/TermosDeServico';
import PoliticaDePrivacidade from './components/legal/PoliticaDePrivacidade';

import { PrivateRoute } from './components/auth/PrivateRoute';

function App() {
  return (
    <Router basename="/app">
      <Routes>
        {/*
          =============================================
          ROTA PAI (Layout Principal)
          path="/" (Isto será o caminho base para todos os filhos)
          element={<MainLayout />} (Isto é o componente fixo)
          =============================================
        */}
        <Route path="/" element={<MainLayout />}>
          {/* ROTAS FILHAS (Renderizadas dentro do <Outlet /> do MainLayout) 
            
            1. Rota de Índice (Index Route): 
               path="" (ou index) significa que ele corresponde exatamente ao caminho do pai.
               Ou seja, quando o URL for exatamente '/', renderiza a HomePage.
          */}
          <Route index element={<HomePage />} />

          {/* 2. Rotas Nomeadas:
               path="cadastro" + caminho do pai ('/') resulta em /cadastro
          */}
          <Route path="cadastro" element={<Cadastro />} />
          <Route path="login" element={<Login />} />
          <Route path="recursos" element={<Recursos />} />
          <Route path="servicos" element={<Servicos />} />
          <Route path="precos" element={<Precos />} />
          <Route path="contato" element={<Contato />} />
          <Route path="termos" element={<TermosDeServico />} />
          <Route path="privacidade" element={<PoliticaDePrivacidade />} />

          <Route element={<PrivateRoute />}>
            {/* Rotas Admin */}
            <Route path="dashboard-admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="usuarios" element={<AdminUsuarios />} />
              <Route path="planos" element={<AdminPlanos />} />
              <Route path="relatorios" element={<AdminRelatorios />} />
              <Route path="sinapi" element={<SinapiUpload />} />
              <Route path="configuracoes" element={<AdminConfiguracoes />} />
              <Route path="ajuda" element={<AdminAjuda />} />
            </Route>

            {/* Rotas Cliente */}
            <Route path="dashboard-cliente" element={<ClientLayout />}>
              <Route index element={<ClientDashboard />} />
              <Route path="novo-orcamento" element={<ClientNovoOrcamento />} />
              <Route path="historico" element={<ClientHistorico />} />
              <Route path="configuracoes" element={<ClientConfiguracoes />} />
              <Route path="perfil" element={<ClientPerfil />} />
              <Route path="ajuda" element={<ClientAjuda />} />
            </Route>
          </Route>
        </Route>

        {/*
          OPCIONAL: Rotas sem Layout (Ex: Páginas de Erro 404)
          Se você quiser que uma página não tenha o layout fixo, 
          defina-a FORA da rota Pai.
        */}
        {/* <Route path="*" element={<Pagina404 />} /> */}
      </Routes>
    </Router>
  );
}

export default App;